import './App.css';
import Profile from './features/profile/Profile';

function App() {
  return <Profile/>;
}

export default App;
